import "../CSS/itemUsuario.css";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

function ItemUsuario(props) {
  const [sexo, setSexo] = useState("trabajador");
  const [estado, setEstado] = useState("#E1F4B2");
  
  useEffect(() => {
    if (props.sexo == "Mujer") setSexo("trabajadora");
    if (props.estado == "NO HABILITADO") setEstado("#FF8D8D");
	if (props.estado == "HABILITADO") setEstado("#E1F4B2");

	console.log(props.estado)
  }, []);
  return (
    <div className="user-card">
      <div className="user-infocard">
        <img
          id="imagenTienda"
          className="user-icon"
          src={require(`../img/${sexo}.png`)}
          alt="flecha"
        />
        <div className="user-info">
          <div>
            <h5 className="user-nombre">{props.nombre}</h5>
            <small>DNI: {props.dni}      |     CIP : {props.cip}  </small>
			
          </div>
        </div>
		{/*
        <Link to={`/panelAdmin/usuario/${props.id}`}>
          <img
            id="imagenTienda"
            className="user-icon"
            src={require(`../img/editar.png`)}
            alt="flecha"
          />
        </Link>

        <img
          className="user-icon"
          src={require(`../img/borrar.png`)}
          alt="borrar"
          onClick={() => props.deleteUsuario(props.id)}
        />*/}
        <div className="user-state">
          <h5 className="user-textState" style={{ backgroundColor:`${estado}`}}>{props.estado}</h5>
        </div>
      </div>
    </div>
  );
}

export default ItemUsuario;
